import React from 'react';
import Layout from '../components/Layout';
import MobileLayout from '../components/Mobile/MobileLayout';
import { useIsMobile } from '../hooks/useIsMobile';
import { Container } from 'react-bootstrap';

const Terms: React.FC = () => {
  const isMobile = useIsMobile();

  const content = (
    <Container className="py-4 px-3" style={{ maxWidth: '896px' }}>
      <div className="bg-white rounded-3 shadow p-4 p-md-5">
        <h1 className="fw-bold text-dark mb-4" style={{ fontSize: '30px' }}>Terms of Service</h1>

        <div className="text-secondary mb-4" style={{ fontSize: '14px' }}>
          Last Updated: {new Date().toLocaleDateString()}
        </div>

        <section className="mb-5">
          <h2 className="fw-bold text-dark mb-3" style={{ fontSize: '20px' }}>1. Acceptance of Terms</h2>
          <p className="text-secondary mb-3">
            By accessing or using NayaBajar ("Service"), you agree to be bound by these Terms of Service ("Terms").
            If you do not agree to these Terms, please do not use our Service.
          </p>
        </section>

        <section className="mb-5">
          <h2 className="fw-bold text-dark mb-3" style={{ fontSize: '20px' }}>2. Description of Service</h2>
          <p className="text-secondary mb-3">
            NayaBajar is an online classifieds platform that allows users to buy, sell, and exchange goods and services.
            Our Service includes:
          </p>
          <ul className="text-secondary" style={{ paddingLeft: '20px' }}>
            <li className="mb-2">Posting advertisements for products and services</li>
            <li className="mb-2">Browsing and searching listings</li>
            <li className="mb-2">Communicating with other users</li>
            <li>Purchasing featured/boosted listings</li>
          </ul>
        </section>

        <section className="mb-5">
          <h2 className="fw-bold text-dark mb-3" style={{ fontSize: '20px' }}>3. User Accounts</h2>
          <h3 className="fs-5 fw-semibold text-dark mb-2">3.1 Account Creation</h3>
          <p className="text-secondary mb-3">
            To use certain features of the Service, you must create an account. You agree to:
          </p>
          <ul className="text-secondary mb-3" style={{ paddingLeft: '20px' }}>
            <li className="mb-2">Provide accurate, current, and complete information</li>
            <li className="mb-2">Maintain and update your account information</li>
            <li className="mb-2">Keep your password secure and confidential</li>
            <li>Notify us immediately of unauthorized use</li>
          </ul>

          <h3 className="fs-5 fw-semibold text-dark mb-2">3.2 Account Responsibilities</h3>
          <p className="text-secondary mb-3">
            You are solely responsible for all activities that occur under your account.
            You agree to notify us immediately of any unauthorized use of your account.
          </p>
        </section>

        <section className="mb-5">
          <h2 className="fw-bold text-dark mb-3" style={{ fontSize: '20px' }}>4. User Conduct</h2>
          <p className="text-secondary mb-3">
            You agree NOT to use the Service to:
          </p>
          <ul className="text-secondary" style={{ paddingLeft: '20px' }}>
            <li className="mb-2">Post false, misleading, or fraudulent listings</li>
            <li className="mb-2">Sell illegal or prohibited items</li>
            <li className="mb-2">Impersonate any person or entity</li>
            <li className="mb-2">Violate any applicable laws or regulations</li>
            <li className="mb-2">Spam, harass, or harm other users</li>
            <li className="mb-2">Upload viruses or malicious code</li>
            <li>Attempt to gain unauthorized access to our systems</li>
          </ul>
        </section>

        <section className="mb-5">
          <h2 className="fw-bold text-dark mb-3" style={{ fontSize: '20px' }}>5. Listings and Transactions</h2>
          <h3 className="fs-5 fw-semibold text-dark mb-2">5.1 Listing Guidelines</h3>
          <ul className="text-secondary mb-3" style={{ paddingLeft: '20px' }}>
            <li className="mb-2">Listings must be accurate and complete</li>
            <li className="mb-2">Items must be legally owned by the seller</li>
            <li className="mb-2">Prohibited items include: stolen goods, weapons, illegal drugs, counterfeit items</li>
            <li>We reserve the right to remove any listing without notice</li>
          </ul>

          <h3 className="fs-5 fw-semibold text-dark mb-2">5.2 Transactions</h3>
          <p className="text-secondary mb-3">
            NayaBajar is not a party to any transaction between users. We do not:
          </p>
          <ul className="text-secondary" style={{ paddingLeft: '20px' }}>
            <li className="mb-2">Guarantee the authenticity or quality of items</li>
            <li className="mb-2">Provide payment processing or escrow services</li>
            <li>Offer buyer protection or insurance</li>
          </ul>
        </section>

        <section className="mb-5">
          <h2 className="fw-bold text-dark mb-3" style={{ fontSize: '20px' }}>6. Fees and Payments</h2>
          <p className="text-secondary mb-3">
            Basic listings are free. We may charge fees for:
          </p>
          <ul className="text-secondary mb-3" style={{ paddingLeft: '20px' }}>
            <li className="mb-2">Featured/boosted listings</li>
            <li className="mb-2">Premium membership plans</li>
            <li>Additional promotional services</li>
          </ul>
          <p className="text-secondary">
            All fees are non-refundable unless otherwise stated.
          </p>
        </section>

        <section className="mb-5">
          <h2 className="fw-bold text-dark mb-3" style={{ fontSize: '20px' }}>7. Intellectual Property</h2>
          <p className="text-secondary mb-3">
            The Service and its original content, features, and functionality are owned by NayaBajar
            and are protected by international copyright, trademark, and other intellectual property laws.
          </p>
        </section>

        <section className="mb-5">
          <h2 className="fw-bold text-dark mb-3" style={{ fontSize: '20px' }}>8. Termination</h2>
          <p className="text-secondary mb-3">
            We reserve the right to suspend or terminate your account at any time for:
          </p>
          <ul className="text-secondary" style={{ paddingLeft: '20px' }}>
            <li className="mb-2">Violation of these Terms</li>
            <li className="mb-2">Fraudulent or illegal activities</li>
            <li>Inactivity for 12+ months</li>
          </ul>
        </section>

        <section className="mb-5">
          <h2 className="fw-bold text-dark mb-3" style={{ fontSize: '20px' }}>9. Dispute Resolution</h2>
          <p className="text-secondary mb-3">
            Any disputes arising from these Terms shall be governed by the laws of Nepal.
            Users agree to resolve disputes through amicable negotiation before pursuing legal action.
          </p>
        </section>

        <section className="mb-5">
          <h2 className="fw-bold text-dark mb-3" style={{ fontSize: '20px' }}>10. Limitation of Liability</h2>
          <p className="text-secondary mb-3">
            NayaBajar shall not be liable for any indirect, incidental, special, consequential,
            or punitive damages resulting from your use of the Service.
          </p>
        </section>

        <section className="mb-5">
          <h2 className="fw-bold text-dark mb-3" style={{ fontSize: '20px' }}>11. Changes to Terms</h2>
          <p className="text-secondary">
            We may modify these Terms at any time. Continued use of the Service after changes
            constitutes acceptance of the new Terms.
          </p>
        </section>

        <section>
          <h2 className="fw-bold text-dark mb-3" style={{ fontSize: '20px' }}>12. Contact Us</h2>
          <p className="text-secondary">
            For questions about these Terms, please contact us at{' '}
            <a href="mailto:support@nayabajar.com" className="text-primary">
              support@nayabajar.com
            </a>
          </p>
        </section>
      </div>
    </Container>
  );

  return isMobile ? <MobileLayout>{content}</MobileLayout> : <Layout showSidebar={false}>{content}</Layout>;
};

export default Terms;
